<div class="product-availability">
  @if (isDesktopLgUp()) {
    <h3 class="product-availability-title text-h4-s">наличие товара</h3>
    <sd-product-availability-current-product [product]="product()"></sd-product-availability-current-product>

    <div class="product-availability-grid">
      <div class="product-availability-grid-item">
        <div class="product-availability-search">
          <ui-address-suggestions-select
            placeholder="ближайший к вам адрес"
            (changeAddress)="onChangeAddress($event)"
          ></ui-address-suggestions-select>
        </div>

        <div #shopListRef class="product-availability-list">
          <sd-shop-list
            [shops]="shopsSorted()"
            [activeShopName]="activeShopId()"
            [showAvailability]="true"
            (clickShop)="onClickShop($event, MAP_ZOOM_ON_SHOP_SELECT)"
          ></sd-shop-list>
        </div>
      </div>
      <div class="product-availability-grid-item">
        <sd-product-availability-info-product
          [forceInStock]="forceInStock()"
          [product]="product()"
        ></sd-product-availability-info-product>
        <div class="product-availability-map">
          <sd-shop-map
            [shops]="shops()"
            (created)="onMapCreated($event)"
            (placemarkClick)="onClickShop($event)"
            [placemarksProps]="getPlacemarksProps"
            [placemarkIconOptions]="getPlacemarkIconOptions"
          ></sd-shop-map>
        </div>
      </div>
    </div>
  } @else {
    <div class="product-availability-search">
      <ui-address-suggestions-select
        placeholder="ближайший к вам адрес"
        [showBackArrow]="openedSearch()"
        [suppressEmptyDropdown]="openedSearch()"
        (changeAddress)="onChangeAddress($event)"
        (handleOpened)="onHandleOpened($event)"
        (backArrowClick)="openedSearch.set(false)"
      ></ui-address-suggestions-select>
    </div>

    @if (!openedSearch()) {
      <sd-product-availability-info-product
        [forceInStock]="forceInStock()"
        [product]="product()"
      ></sd-product-availability-info-product>
    }

    <div class="product-availability-map">
      <sd-shop-map
        [shops]="shops()"
        [showBalloon]="false"
        (created)="onMapCreated($event)"
        (placemarkClick)="onPlacemarkClick($event)"
        [placemarksProps]="getPlacemarksProps"
        [placemarkIconOptions]="getPlacemarkIconOptions"
      ></sd-shop-map>
    </div>

    @if (openedSearch()) {
      <div #shopListRef class="product-availability-list product-availability-list--overlay">
        @if (!searchHasText()) {
          <sd-shop-list
            [shops]="shopsSorted()"
            [activeShopName]="activeShopId()"
            [showAvailability]="true"
            (clickShop)="onClickShop($event)"
          ></sd-shop-list>
        }
      </div>
    }

    <sd-product-availability-current-product [product]="product()"></sd-product-availability-current-product>
  }
</div>
